/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ModelMapParameterMapLayerConfiguration } from './model-map-parameter-map-layer-configuration';
// May contain unused imports in some cases
// @ts-ignore
import type { ParameterTimeSeriesConfiguration } from './parameter-time-series-configuration';
// May contain unused imports in some cases
// @ts-ignore
import type { ParametersGeoBoundingBox } from './parameters-geo-bounding-box';
// May contain unused imports in some cases
// @ts-ignore
import type { StaticMapOverlaysOverlayConfiguration } from './static-map-overlays-overlay-configuration';

/**
 * 
 * @export
 * @interface ModelMapWidgetConfigurationAllOf
 */
export interface ModelMapWidgetConfigurationAllOf {
    /**
     * 
     * @type {string}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'type': ModelMapWidgetConfigurationAllOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'model_id': string;
    /**
     * 
     * @type {ParametersGeoBoundingBox}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'initial_viewport_bounds': ParametersGeoBoundingBox;
    /**
     * 
     * @type {string}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'base_layer_style': ModelMapWidgetConfigurationAllOfBaseLayerStyleEnum;
    /**
     * 
     * @type {Array<ParameterTimeSeriesConfiguration>}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'parameter_time_series_configurations': Array<ParameterTimeSeriesConfiguration>;
    /**
     * 
     * @type {Array<ModelMapParameterMapLayerConfiguration>}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'parameter_map_layer_configurations': Array<ModelMapParameterMapLayerConfiguration>;
    /**
     * 
     * @type {Array<StaticMapOverlaysOverlayConfiguration>}
     * @memberof ModelMapWidgetConfigurationAllOf
     */
    'static_map_overlay_configurations': Array<StaticMapOverlaysOverlayConfiguration>;
}

export const ModelMapWidgetConfigurationAllOfTypeEnum = {
    ModelMap: 'model_map'
} as const;

export type ModelMapWidgetConfigurationAllOfTypeEnum = typeof ModelMapWidgetConfigurationAllOfTypeEnum[keyof typeof ModelMapWidgetConfigurationAllOfTypeEnum];
export const ModelMapWidgetConfigurationAllOfBaseLayerStyleEnum = {
    FullColor: 'full_color',
    Monochrome: 'monochrome'
} as const;

export type ModelMapWidgetConfigurationAllOfBaseLayerStyleEnum = typeof ModelMapWidgetConfigurationAllOfBaseLayerStyleEnum[keyof typeof ModelMapWidgetConfigurationAllOfBaseLayerStyleEnum];


